import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import {
  ClientSentryEventContext,
  ClientSentryIgnoreRule,
} from '@/shared/utils/sentry/clientIgnoreRules/types';

const CUSTOM_EVENT_UNHANDLED_REJECTION_MESSAGE =
  'event `customevent` (type=unhandledrejection) captured as promise rejection';

const hasActionableContext = ({
  hasExceptionStacktrace,
  hasAppFrameInStacktrace,
}: ClientSentryEventContext): boolean =>
  hasExceptionStacktrace || hasAppFrameInStacktrace;

export const customEventUnhandledRejectionWithoutStackContextRule: ClientSentryIgnoreRule =
  {
    id: 'custom-event-unhandled-rejection-without-stack-context',
    references: ['FTR-3503'],
    reason:
      'Opaque CustomEvent rejection with no usable seller-ui stack or app-frame context',
    matches: (context) => {
      if (context.firstExceptionType !== 'CustomEvent') {
        return false;
      }

      if (hasActionableContext(context)) {
        return false;
      }

      return (
        toNormalizedMessage(context.serializedMessage) ===
        CUSTOM_EVENT_UNHANDLED_REJECTION_MESSAGE
      );
    },
  };
